import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { axiosObj } from "../../../config/apiClients";
import { queryParams } from "../../../utils/interface";
import { TransactionStatsState } from "../../types";

const initialState: TransactionStatsState = {
  isLoading: false,
  transactionStats: [],
};

export const getAllStats = createAsyncThunk(
  "/transaction-stats",
  async ({ startDate, endDate }: queryParams, { rejectWithValue }) => {
    try {
      const params = new URLSearchParams();

      if (startDate) params.append("startDate", startDate as string);
      if (endDate) params.append("endDate", endDate as string);

      const response = await axiosObj.get(
        `/transaction-stats?${params.toString()}`
      );

      return response.data;
    } catch (error: any) {
      return rejectWithValue(
        error?.response?.data || { message: "Failed to Fetch Transaction Stats" }
      );
    }
  }
);

const transactionStatsSlice = createSlice({
  name: "TransactionStats",
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(getAllStats.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getAllStats.fulfilled, (state, action) => {
        state.isLoading = false;
        state.transactionStats =
          action.payload?.payload || [];
      })
      .addCase(getAllStats.rejected, (state) => {
        state.isLoading = false;
        state.transactionStats = [];
      });
  },
});

export default transactionStatsSlice.reducer;